import { compose } from 'redux';
import { connect } from 'react-redux';
import withReducer from '@Hooks/withReducer';

import { treeViewReducerKey } from './TreeViewConstants';
import {
  taxonomies as taxonomiesSelector,
  selectedListExpanded as selectedListExpandedSelector,
  selectedTaxonomies as selectedTaxonomiesSelector,
  initialConfig as initialConfigSelector,
} from './TreeViewSelectors';
import TreeViewReducer from './TreeViewReducer';

import { init, setSelectedListExpanded, toggleTaxonomy, loadTaxonomy, selectTaxonomy, removeTaxonomy, resetState } from './TreeViewActions';
import TreeView from './TreeView';

const mapStateToProps = (state) => ({
  taxonomies: taxonomiesSelector(state),
  selectedListExpanded: selectedListExpandedSelector(state),
  selectedTaxonomies: selectedTaxonomiesSelector(state),
  initialConfig: initialConfigSelector(state),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  init: () => dispatch(init(ownProps)),
  onReset: () => dispatch(resetState()),
  toggleSelectedList: (expanded) => dispatch(setSelectedListExpanded(expanded)),
  selectTaxonomy: (taxonomy) => dispatch(selectTaxonomy(taxonomy)),
  toggleTaxonomy: (taxonomy) => dispatch(toggleTaxonomy(taxonomy)),
  loadTaxonomy: (currentTaxonomy) => dispatch(loadTaxonomy(currentTaxonomy)),
  removeTaxonomy: (currentTaxonomy) => dispatch(removeTaxonomy(currentTaxonomy, ownProps.selectedCustomItems)),
});

export default compose(withReducer(treeViewReducerKey, TreeViewReducer), connect(mapStateToProps, mapDispatchToProps))(TreeView);
